var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('card',{staticClass:"stacked-form"},[(_vm.orderEmailText !== null)?_c('warehouse-form',{attrs:{"init-warehouse":{ order_email_text: _vm.orderEmailText },"val-errors":_vm.valErrors,"submit-text":"Erstellen"},on:{"submit":_vm.submit}}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }